<template>
    <Main>
        <box-loading v-if="isLoading"></box-loading>
        <div v-else class="input-kintone">
            <el-row :gutter="20">
                <el-col :span="10" :xs="24">
                    <InputField :span-input="16" :span-label="8" classes="mb-sm-3 mb-1" is-required :label-text="$t('textCommon.space')">
                        <InputText readonly="" :value="dataShare && dataShare['data_workspace'] && dataShare['data_workspace'].name ? dataShare['data_workspace'].name : ''"></InputText>
                    </InputField>
                    <InputField :span-input="16" :span-label="8" classes="mb-sm-3 mb-1" is-required :label-text="$t('textCommon.app')">
                        <InputText readonly="" v-model="dataShare.app_name"></InputText>
                    </InputField>
                </el-col>
                <el-col :span="10" class="pl-sm-5 pl-2" :xs="24">
                    <InputField classes="mb-sm-3 mb-1" :span-input="20" :span-label="4" is-required :label-text="$t('member.list')">
                        <InputText readonly="" v-model="dataShare.view_name"></InputText>
                    </InputField>
                    <InputField :span-label="4" :span-input="20" :label-text="$t('member.role')">
                        <div class="box-roles-user box-roles-user__disabled">
                            <label class="ckbox mb-0" v-for="roleItem in listRoles" :key="roleItem.value">
                                <input v-model="roleUser" disabled type="checkbox" :value="roleItem.value" />
                                <span>{{ $t(roleItem.label) }}</span>
                            </label>
                        </div>
                    </InputField>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mb-3">
                <el-col :span="20" :xs="24">
                    <InputField :span-label="4" :span-input="20" :label-text="$t('member.filter')">
                        <div class="text-filter">{{ filterText }}</div>
                    </InputField>
                </el-col>
            </el-row>
            <div class="table-sm table-kb table-multi-edit">
                <table class="table custom-table table-hover table-common" id="basicExample">
                    <thead>
                        <tr class="header-text">
                            <th v-for="key in listFieldsKeys" v-if="!isInputHidden(key)" :key="key">
                                {{ getTitleByKey(key) }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="listDataShares && listDataShares.length > 0">
                            <tr v-for="(row, index) in listDataShares" :key="index + 'row'" class="row-kintone" :class="{ 'row-kintone__error': onCheckRowError(row['errorInfo']) }">
                                <td v-for="item in listFields" v-if="!isInputHidden(item.code)" :data-title="getTitleByKey(item.code)" :class="{ 'align-top': true, 'col-required': item.required }" :key="item.code + index">
                                  <input-kintone-setting
                                        :disabled="isInputDisabled(item.code)"
                                        v-if="!listInputNotEdit.includes(item.type)"
                                        :type-input="item.type"
                                        v-model="row[item.code]"
                                        :options="item.options"
                                        :lookup="item.lookup"
                                        :data-local="dataMaster"
                                        :formatCalc="item.format"
                                        :protocol-link="item.protocol"
                                        @onValidate="onValidate(item.code)"
                                        :unit="item.unit"
                                    >
                                    </input-kintone-setting>
                                    <div
                                        v-else-if="item.type === TYPE_SUB_TABLE"
                                        style="cursor: pointer"
                                        @click="onShowSubTable(row[item.code], item.code, getTitleByKey(item.code))"
                                        class="col-text-normal text-center"
                                    >
                                        [Data Table]
                                    </div>
                                    <div class="col-text-normal" v-else-if="item.type === TYPE_RICK_TEXT">
                                        <div class="text-note-input text-center">
                                            {{ $t('recordForm.notSupportFormMultiple') }}
                                        </div>
                                    </div>
                                    <div v-else class="col-text-normal">
                                        {{ row[item.code] }}
                                    </div>
                                    <span class="error-message" v-if="row['errorInfo'] && row['errorInfo'][item.code]">
                                        {{ row['errorInfo'][item.code] }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="pagination-old clearfix">
                <div class="pagination__items clearfix">
                    <span class="pagination__items__label">{{ $t('paginator.itemsPerPage') }}</span>
                    <el-select v-model="limit" class="pagination__items__select" @change="onChangeLimit">
                        <el-option v-for="value in perPageList" :key="value" :label="value" :value="value">
                            {{ value }}
                        </el-option>
                    </el-select>
                </div>
                <div class="pagination-old__paginator mt-3 mt-sm-0">
                    <ul class="clearfix mb-0">
                        <li @click="prevPage()">
                            <a href="javascript:void(0)" class="box-left" :class="{ disabled: lastId === 0 }">
                                <i class="el-icon-d-arrow-left"></i>
                            </a>
                        </li>
                        <li class="active">
                            <a href="javascript:void(0)">{{ page }}</a>
                        </li>
                        <li @click="nextPage()">
                            <a href="javascript:void(0)" class="box-right" :class="{ disabled: listDataShares.length < limit }">
                                <i class="el-icon-d-arrow-right"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <template #bottomAction>
            <div class="text-right">
                <Button @click="handleCancelList" type="warning">
                    {{ $t('button.cancel') }}
                </Button>
                <Button classes="ml-3" @click="handleSaveData" type="primary">
                    {{ $t('button.save') }}
                </Button>
            </div>
        </template>
        <popup :show.sync="isShowDataTable" :title="titlePopupSubTable" modal-large>
            <template #content>
                <div class="table-sm table-kb" v-if="tableViewCurrent && listFieldSubTable">
                    <table class="table customer-table table-hover table-common">
                        <thead>
                            <tr>
                                <th
                                    :key="indexTitle"
                                    v-for="(title, indexTitle) in listFieldSubTable.map((elm) => {
                                        return elm.label;
                                    })"
                                >
                                    {{ title }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="tableViewCurrent && tableViewCurrent.length > 0">
                                <tr class="row-kintone" v-for="itemRow in tableViewCurrent" :key="itemRow.id">
                                    <td class="py-3" v-for="(itemField, indexF) in Object.assign(itemRow.value)" :key="indexF + '' + itemRow.id">
                                        {{ getValueFieldSubTable(itemField) }}
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td :colspan="listFieldSubTable.length" class="text-center px-2">
                                    <el-empty :description="titlePopupSubTable + ' No Data'"></el-empty>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template #footer>
                <Button @click="isShowDataTable = false" type="warning" classes="btn-sm">{{ $t('button.cancel') }}</Button>
            </template>
        </popup>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import Button from '@/components/partials/Button';
import InputField from '@/components/partials/InputField';
import InputText from '@/components/partials/customs/InputText';
import BoxLoading from '@/components/partials/BoxLoading';
import Popup from '@/components/partials/Popup';
import { addComasNumber, formatDateTime, formatDateTimeZoneWithHour, validEmail } from '@/utils';
import {
    TYPE_CHECK_BOX,
    TYPE_CONTENT_DATE,
    TYPE_CONTENT_TEXT,
    TYPE_DATE_TIME,
    TYPE_MULTI_SELECT,
    TYPE_NUMBER,
    TYPE_SUB_TABLE,
    TYPE_RICK_TEXT,
    PER_PAGE_LIST,
    TYPE_ORGANIZATION_SELECT,
    TYPE_CALC,
    TYPE_DATE,
    TYPE_CREATED_TIME,
    TYPE_UPDATE_TIME,
    TYPE_RADIO_BUTTON,
    TYPE_DROPDOWN,
    TYPE_RECORD_NUMBER,
    TYPE_CREATOR,
    TYPE_MODIFIER,
    TYPE_LINK,
    TYPE_FILE
} from '@/config/constants';
import { mapState } from 'vuex';
import InputKintoneSetting from '@/components/partials/InputKintonSetting';
import isUrl from 'is-url';
export default {
    name: 'edit-multiple-data',
    components: {
        InputKintoneSetting,
        BoxLoading,
        InputText,
        InputField,
        Main,
        Button,
        Popup
    },
    comments: {},
    data() {
        return {
            isShowDataTable: false,
            arrayFieldDisabled: [],
            arrayFieldDetailHidden: [],
            tableViewCurrent: [],
            listFieldSubTable: [],
            titlePopupSubTable: '',
            roleUser: ['detail', '', ''],
            dataShare: null,
            isLoading: false,
            listDataShares: [],
            TYPE_RICK_TEXT,
            TYPE_SUB_TABLE,
            listFields: [],
            listFieldsKeys: [],
            listRolesAccount: [],
            lastId: 0,
            page: 1,
            limit: 10,
            perPageList: PER_PAGE_LIST,
            errorInfo: {},
            dataMaster: {
                users: [],
                groups: [],
                departments: []
            }
        };
    },
    created() {
        let queryId = this.$route.query.id;
        this.onGetAllRoleAccount();
        if (queryId) {
            this.handleGetDetailDataShare(queryId);
            this.handleGetDataShares(queryId);
            this.handleGetListGroupUser(queryId);
        }
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        isAccountAdmin() {
            if (localStorage.getItem('KB_DEV_CUSTOMER') || this.userInfo) {
                let user = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) || this.userInfo;
                if (user) {
                    let roleUser = parseInt(user.type);
                    return roleUser === 2;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        listInputNotEdit() {
            return [TYPE_CREATED_TIME, TYPE_CREATOR, TYPE_UPDATE_TIME, TYPE_MODIFIER, TYPE_RECORD_NUMBER, TYPE_SUB_TABLE, TYPE_RICK_TEXT];
        },
        listRoles() {
            return [
                { label: 'member.roles.view', value: 'detail' },
                { label: 'member.roles.edit', value: 'update' },
                { label: 'member.roles.register', value: 'create' }
            ];
        },
        listAllTypes() {
            return [
                { value: '=', label: this.$t('filter.condition1') },
                { value: '!=', label: this.$t('filter.condition2') },
                { value: 'in', label: this.$t('filter.condition3') },
                { value: 'not in', label: this.$t('filter.condition4') },
                { value: 'like', label: this.$t('filter.condition5') },
                { value: 'not like', label: this.$t('filter.condition6') },
                { value: '<=', label: this.$t('filter.condition7') },
                { value: '<', label: this.$t('filter.condition8') },
                { value: '>=', label: this.$t('filter.condition9') },
                { value: '>', label: this.$t('filter.condition10') }
            ];
        },
        isRoleCreate() {
            return this.roleUser.includes('create');
        },
        isRoleUpdate() {
            return this.roleUser.includes('update');
        },
        filterText() {
            let textResult = '';
            let { listFields, dataShare } = this;
            let dataFilter = dataShare['array_filter'] || [];
            let typeFilter = dataShare['data_filter'] && dataShare['data_filter'].includes(' or ') ? 'or' : 'and';
            if (listFields) {
                if (dataFilter.length === 0) {
                    textResult = this.$t('filter.allRecord');
                } else {
                    dataFilter.map((elm, index) => {
                        if (elm.field) {
                            let indexF = listFields.findIndex((fieldK) => fieldK.code === elm.field);
                            if (indexF >= 0) {
                                textResult += listFields[indexF] ? listFields[indexF].label : '';
                            }

                            let typeIndex = this.listAllTypes.findIndex((type) => type.value === elm.type);
                            if (typeIndex >= 0) {
                                textResult += `    ${this.listAllTypes[typeIndex].label}   `;
                            }
                            if (elm.value && Array.isArray(elm.value)) {
                                textResult += ` (${elm.value.join(' , ')}) `;
                            } else {
                                textResult += ` ${elm.value} `;
                            }
                            if (index < dataFilter.length - 1) {
                                textResult += ` ${typeFilter} `;
                            }
                        }
                    });
                }
            }
            return textResult;
        }
    },
    methods: {
        isInputDisabled(itemCodeField) {
          if (!this.arrayFieldDisabled?.length) return false;
          return this.arrayFieldDisabled.some(item => item.code === itemCodeField) && !this.isAccountAdmin;
        },

      isInputHidden(itemCodeField) {
        if (!this.arrayFieldDetailHidden?.length) return false;
        let hasLayout = this.arrayFieldDetailHidden && Array.isArray(this.arrayFieldDetailHidden) && this.arrayFieldDetailHidden.some(item => 'isHidden' in item || 'row' in item);
        
        if (hasLayout) {
            let fieldLayout = this.arrayFieldDetailHidden.find((item) => item.code === itemCodeField);
            if (fieldLayout) {
                return fieldLayout.isHidden && !this.isAccountAdmin;
            }
            return !this.isAccountAdmin;
        }

        let hiddenCodes = this.arrayFieldDetailHidden.map(h => typeof h === 'object' ? h.code : h);
        return hiddenCodes.includes(itemCodeField) && !this.isAccountAdmin;
      },

        onCheckRowError(errors) {
            let result = false;
            if (errors) {
                for (const [key, value] of Object.entries(errors)) {
                    if (key && value) {
                        result = true;
                    }
                }
            }
            return result;
        },
        onUpdateMultipleData() {
            this.$router.push({
                name: this.isAccountAdmin
                    ? this.$router.currentRoute.name === 'dataLinkMultiDataViewEditMultiple'
                        ? 'dataLinkMultiDataViewEditMultiple'
                        : 'dataViewEditMultiple'
                    : 'dataViewEditMultipleChildren',
                query: {
                    id: this.$route.query.id,
                    link_name: this.$route.query.link_name ?? ''
                }
            });
        },
        handleGetListGroupUser(idShare) {
            let successCallback = (response) => {
                if (response.status === 200) {
                    let { data } = response.data.data;
                    this.dataMaster.users = [].concat(
                        data.user.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster.departments = [].concat(
                        data.department.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster.groups = [].concat(
                        data.group.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster = Object.assign({}, this.dataMaster);
                }
            };
            let errorCallback = () => {};

            let payload = {
                successCallback,
                errorCallback,
                shareId: idShare
            };

            this.$store.dispatch('share/getAllGroupUser', payload);
        },
        onGetAllRoleAccount() {
            let successCallback = (response) => {
                let { data } = response.data;
                this.listRolesAccount = data.role.filter((elm) => elm.type !== 'delete');
            };
            let errorCallback = () => {};

            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('share/getAllRolesUser', payload);
        },
        onShowDetailRecord(row) {
            let idRecord = row['$id'].value;
            let queryId = this.$route.query.id;
            this.$router.push({
                name: this.isAccountAdmin ? (this.$router.currentRoute.name === 'dataLinkMultiDataViewEditMultiple' ? 'dataLinkMultiDataViewDetail' : 'dataViewDetail') : 'dataViewDetailChildren',
                query: {
                    idShare: queryId,
                    idRecord: idRecord,
                    update: this.isRoleUpdate ? 1 : 0,
                    link_name: this.$route.query.link_name ?? ''
                }
            });
        },
        handleCancelList() {
            this.$router.push({
                name: this.isAccountAdmin ? (this.$router.currentRoute.name === 'dataLinkMultiDataViewEditMultiple' ? 'dataLinkMultiDataView' : 'dataView') : 'dataViewChildren',
                query: {
                    id: this.$route.query.id,
                    idDataLink: this.$route.query.idDataLink ?? '',
                    link_name: this.$route.query.link_name ?? ''
                }
            });
        },
        handleSaveData() {
            let checkValid = this.onValidate();
            if (checkValid) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    let responseData = response.data.data.data;
                    let statusError = responseData.status || false;
                    if (statusError) {
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: this.$t('recordForm.msgUpdateSuccessfully')
                        });
                        this.$router.push({
                            name: this.isAccountAdmin ? (this.$router.currentRoute.name === 'dataLinkMultiDataViewEditMultiple' ? 'dataLinkMultiDataView' : 'dataView') : 'dataViewChildren',
                            query: {
                                id: this.$route.query.id,
                                idDataLink: this.$route.query.idDataLink ?? '',
                                link_name: this.$route.query.link_name ?? ''
                            }
                        });
                    } else {
                        let messageError = responseData.error ? `[${responseData.error.code}] ${responseData.error.message}` : '';
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'error',
                            message: messageError
                        });
                    }
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let dataPayload = [];
                this.listDataShares.map((recordShare) => {
                    let objectRecord = {};
                    Object.keys(recordShare).map((key) => {
                        let typeField = '';
                        let indexField = this.listFields.findIndex((elm) => elm.code === key);
                        if (indexField >= 0 || key === '$id') {
                            if (key === '$id') {
                                objectRecord[key] = {
                                    type: '__ID__',
                                    value: recordShare[key]
                                };
                            } else {
                                typeField = this.listFields[indexField].type;
                                if (typeField !== TYPE_SUB_TABLE) {
                                    if (typeField === TYPE_DATE_TIME) {
                                        objectRecord[key] = {
                                            type: typeField,
                                            value: recordShare[key] ? formatDateTimeZoneWithHour('', recordShare[key]) : ''
                                        };
                                    } else if (typeField === TYPE_DATE) {
                                        objectRecord[key] = {
                                            type: typeField,
                                            value: recordShare[key] ? formatDateTime(recordShare[key], 'YYYY-MM-DD') : ''
                                        };
                                    } else if ([TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(typeField)) {
                                        objectRecord[key] = {
                                            type: typeField,
                                            value: recordShare[key] && this.$ld.isArray(recordShare[key]) ? recordShare[key].join(';') : recordShare[key]
                                        };
                                    } else if (typeField === TYPE_CALC || typeField === TYPE_FILE) {
                                        objectRecord[key] = {
                                            type: typeField,
                                            value: ''
                                        };
                                    } else {
                                        objectRecord[key] = {
                                            type: typeField,
                                            value: recordShare[key]
                                        };
                                    }
                                } else {
                                    if (recordShare[key]) {
                                        let dataTable = [];
                                        recordShare[key].map((elm) => {
                                            let obj = {
                                                id: elm.id,
                                                value: {}
                                            };
                                            let valueElm = elm.value;
                                            Object.keys(valueElm).map((keyField) => {
                                                obj.value[keyField] = {
                                                    type: valueElm[keyField].type,
                                                    value: valueElm[keyField].value
                                                };
                                                if ([TYPE_CHECK_BOX, TYPE_DROPDOWN, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(valueElm[keyField].type)) {
                                                    if (obj.value[keyField].value && Array.isArray(obj.value[keyField].value)) {
                                                        obj.value[keyField].value = obj.value[keyField].value ? obj.value[keyField].value.join(';') : '';
                                                    }
                                                } else if (valueElm[keyField].type === TYPE_DATE_TIME) {
                                                    obj.value[keyField].value = obj.value[keyField].value ? formatDateTimeZoneWithHour('', obj.value[keyField].value) : '';
                                                } else if (valueElm[keyField].type === TYPE_DATE) {
                                                    obj.value[keyField].value = obj.value[keyField].value ? formatDateTime(obj.value[keyField].value, 'YYYY-MM-DD') : '';
                                                } else if (valueElm[keyField].type === TYPE_CALC || valueElm[keyField].type === TYPE_FILE) {
                                                    obj.value[keyField].value = '';
                                                }
                                            });
                                            dataTable.push(obj);
                                        });

                                        dataTable = dataTable.filter((elm) => elm.id);

                                        objectRecord[key] = {
                                            type: typeField,
                                            value: dataTable
                                        };
                                    }
                                }
                            }
                        }
                    });
                    dataPayload.push(objectRecord);
                });

                let payload = {
                    successCallback,
                    errorCallback,
                    data: dataPayload,
                    shareId: this.$route.query.id
                };
                this.$store.dispatch('share/updateMultipleDataShare', payload);
            } else {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'error',
                    message: 'Error, Please check table data !'
                });
            }
        },
        onValidate(field) {
            let check = true;
            let { listDataShares } = this;
            listDataShares.map((recordShare) => {
                if (recordShare) {
                    recordShare.errorInfo = {};
                    let listDataRequired = this.listFields.filter(this.filterCondition);
                    listDataRequired.map((elm) => {
                        recordShare.errorInfo[elm.code] = '';
                        if (!field || field === elm.code) {
                            if (elm.type === TYPE_LINK) {
                                recordShare.errorInfo[elm.code] = '';
                                if (recordShare[elm.code]) {
                                    if (elm.protocol === 'WEB' && !isUrl(recordShare[elm.code])) {
                                        check = false;
                                        recordShare.errorInfo[elm.code] = this.$t('msgCommon.msgLinkFormat', { field: elm.label });
                                    }
                                    if (elm.protocol === 'MAIL' && !validEmail(recordShare[elm.code])) {
                                        check = false;
                                        recordShare.errorInfo[elm.code] = this.$t('pageLogin.errorMailFormat');
                                    }
                                    if (elm.protocol === 'CALL') {
                                    }
                                }
                            } else if (!recordShare[elm.code] || (recordShare[elm.code] && Array.isArray(recordShare[elm.code]) && recordShare[elm.code].length === 0)) {
                                recordShare.errorInfo[elm.code] = this.$t('msgCommon.msgRequired', { field: elm.label });
                                check = false;
                            }
                        }
                    });
                }
            });
            this.listDataShares = [].concat(this.listDataShares);
            return check;
        },
        filterCondition(item) {
            let result = false;
            if (item) {
                if (item.required) {
                    result = true;
                } else if (item.type === TYPE_LINK) {
                    result = true;
                } else {
                    result = false;
                }
            }
            return result;
        },
        handleGetDetailDataShare(queryId) {
            this.isLoading = true;
            let successCallback = (response) => {
                this.dataShare = response.data?.data?.data;
                this.arrayFieldDisabled = response.data?.data?.data?.array_field_disabled;
                this.arrayFieldDetailHidden = response.data?.data?.data?.array_field_detail_hidden;
                let dataShareRole = this.dataShare.list_role;
                this.roleUser = dataShareRole
                    .filter((elm) => elm.enable)
                    .map((elm) => {
                        return elm.type;
                    });
                this.isLoading = false;
            };

            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: queryId
            };
            this.$store.dispatch('connect/getDetailConnect', payload);
        },
        handleGetDataShares(queryId) {
            this.isLoading = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                    let { data } = response.data.data;
                  console.log(data.fields);
                    let dataRecordList = data.records || [];
                    this.listDataShares = [];
                    this.listFields = [];
                    this.$ld.map(dataRecordList, (valueRecord, indexRecord) => {
                        let dataRecord = {};
                        Object.keys(valueRecord).map((key) => {
                            if (valueRecord[key] && [TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(valueRecord[key].type)) {
                                dataRecord[key] = valueRecord[key].value ? valueRecord[key].value.split(';') : [];
                            } else if (valueRecord[key] && valueRecord[key].type === TYPE_SUB_TABLE) {
                                let dataRecordTable = [].concat(valueRecord[key].value);
                                let dataTable = [];
                                dataRecordTable.map((elm) => {
                                    let objData = {
                                        id: elm.id,
                                        value: {}
                                    };
                                    Object.keys(elm.value).map((keyTab) => {
                                        if (elm.value[keyTab] && [TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(elm.value[keyTab].type)) {
                                            objData['value'][keyTab] = {
                                                type: elm.value[keyTab].type,
                                                value: elm.value[keyTab].value ? elm.value[keyTab].value.split(';') : []
                                            };
                                        } else if (elm.value[keyTab].type === TYPE_RICK_TEXT) {
                                            objData['value'][keyTab] = {
                                                type: elm.value[keyTab].type,
                                                value: elm.value[keyTab].value ? elm.value[keyTab].value.replaceAll('<div>', '<p>').replaceAll('</div>', '</p>') : ''
                                            };
                                        } else {
                                            if (elm.value[keyTab]) {
                                                objData['value'][keyTab] = {
                                                    type: elm.value[keyTab].type,
                                                    value: elm.value[keyTab].value || ''
                                                };
                                            }
                                        }
                                    });
                                    dataTable.push(objData);
                                });
                                dataRecord[key] = dataTable;
                            } else if (valueRecord[key] && valueRecord[key].type === TYPE_RICK_TEXT) {
                                dataRecord[key] = valueRecord[key].value ? valueRecord[key].value.replaceAll('<div>', '<p>').replaceAll('</div>', '</p>') : '';
                            } else {
                                dataRecord[key] = valueRecord[key].value;
                            }
                        });
                        this.listDataShares.push(dataRecord);
                        if (data.fields) {
                            Object.keys(data.fields).map((key) => {
                                this.errorInfo[key] = '';
                                let typeField = data.fields[key].type;
                                if (typeField === TYPE_RADIO_BUTTON || typeField === TYPE_CHECK_BOX) {
                                    let fieldItem = Object.assign({}, data.fields[key]);
                                    let fieldItemOptions = data.fields[key].options;
                                    fieldItem.options = [];
                                    if (this.$ld.isArray(fieldItemOptions)) {
                                        fieldItem.options = fieldItemOptions.map((elm) => {
                                            return elm.label;
                                        });
                                    } else if (this.$ld.isObject(fieldItemOptions)) {
                                        Object.keys(fieldItemOptions).map((keyField) => {
                                            fieldItem.options.push({
                                                label: keyField,
                                                value: keyField
                                            });
                                        });
                                    }

                                    if (indexRecord === 0) {
                                        this.listFields.push(fieldItem);
                                    }
                                } else if (typeField === TYPE_SUB_TABLE) {
                                    let fieldItem = data.fields[key];
                                    let fieldItems = data.fields[key].fields;
                                    let isEmptyTable = dataRecord[fieldItem.code] && dataRecord[fieldItem.code].length === 0;
                                    let objEmpty = {};
                                    fieldItem.fields = [];
                                    Object.keys(fieldItems).map((keyField, indexF) => {
                                        fieldItem.fields.push(fieldItems[keyField]);
                                        if (isEmptyTable) {
                                            objEmpty[keyField] = {
                                                type: fieldItems[keyField].type,
                                                value: fieldItems[keyField].defaultValue || ''
                                            };
                                        }
                                        if (fieldItems[keyField] && fieldItems[keyField].options) {
                                            let optionList = [];
                                            Object.keys(fieldItems[keyField].options).map((optionKey) => {
                                                optionList.push({
                                                    value: optionKey,
                                                    label: optionKey
                                                });
                                            });
                                            if (!isEmptyTable) {
                                                dataRecord[fieldItem.code].forEach((elm, indexRow) => {
                                                    if (elm && elm.value) {
                                                        Object.keys(elm.value).map((keyF) => {
                                                            let typeInputCheck = elm.value[keyF].type;
                                                            if ([TYPE_CHECK_BOX, TYPE_RADIO_BUTTON].includes(typeInputCheck)) {
                                                                elm.value[keyF].options = optionList.sort(function (a, b) {
                                                                    return a.label.localeCompare(b.label);
                                                                });
                                                            } else if ([TYPE_DROPDOWN, TYPE_MULTI_SELECT].includes(typeInputCheck)) {
                                                                elm.value[keyF].options = fieldItems[keyF] ? Object.keys(fieldItems[keyF].options).sort() : [];
                                                            } else if (typeInputCheck === TYPE_CALC) {
                                                                elm.value[keyF].format = fieldItems[keyF].format;
                                                            }
                                                        });
                                                    }
                                                });
                                            } else {
                                                if ([TYPE_CHECK_BOX, TYPE_RADIO_BUTTON].includes(fieldItems[keyField].type)) {
                                                    objEmpty[keyField].options = optionList.sort(function (a, b) {
                                                        return a.label.localeCompare(b.label);
                                                    });
                                                } else if (fieldItems[keyField].type === TYPE_DROPDOWN || fieldItems[keyField].type === TYPE_MULTI_SELECT) {
                                                    objEmpty[keyField].options = Object.keys(fieldItems[keyField].options).sort();
                                                } else if (fieldItems[keyField].type === TYPE_CALC) {
                                                    objEmpty[keyField].format = fieldItems[keyField].format;
                                                }
                                            }
                                        }
                                        if (fieldItems[keyField] && fieldItems[keyField].lookup) {
                                            if (!isEmptyTable) {
                                                dataRecord[fieldItem.code].forEach((elm, indexRow) => {
                                                    if (elm && elm.value) {
                                                        Object.keys(elm.value).map((keyF) => {
                                                            if (keyField === keyF) {
                                                                elm.value[keyF].lookup = fieldItems[keyField].lookup;
                                                            }
                                                        });
                                                    }
                                                });
                                            } else {
                                                objEmpty[keyField].lookup = fieldItems[keyField].lookup;
                                            }
                                        }
                                    });
                                    if (isEmptyTable) {
                                        dataRecord[fieldItem.code] = [{ id: '', value: objEmpty }];
                                    }
                                    if (indexRecord === 0) {
                                        this.listFields.push(fieldItem);
                                    }
                                } else if (typeField === TYPE_DROPDOWN || typeField === TYPE_MULTI_SELECT) {
                                    if (indexRecord === 0) {
                                        data.fields[key].options = Object.keys(data.fields[key].options).sort();
                                        this.listFields.push(data.fields[key]);
                                    }
                                } else {
                                    if (indexRecord === 0) {
                                        this.listFields.push(data.fields[key]);
                                    }
                                }
                            });
                        }
                        let index = this.listFields.findIndex((elm) => elm.type === TYPE_RECORD_NUMBER);
                        if (index >= 0) {
                            const itemRecordNumber = this.listFields[index];
                            this.listFields.splice(index, 1);
                            this.listFields.unshift(itemRecordNumber);
                        }
                    });
                    this.listFieldsKeys = Object.keys(data.fields);
                }
                setTimeout(() => {
                    this.isLoading = false;
                }, 1000);
            };

            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                shareId: queryId,
                query: this.getQueryString()
            };
            this.$store.dispatch('share/getListShareData', payload);
        },
        onShowSubTable(tableData, keyTable, titleTable) {
            if (keyTable) {
                let index = this.listFields.findIndex((elm) => elm.code === keyTable);
                let fields = {};
                if (index >= 0) {
                    fields = this.listFields && this.listFields[index] ? this.listFields[index].fields : {};
                }

                this.listFieldSubTable = [];
                Object.keys(fields).map((key) => {
                    let objItem = {
                        code: key,
                        label: fields[key].label
                    };
                    this.listFieldSubTable.push(objItem);
                });
            }
            this.titlePopupSubTable = titleTable;
            this.isShowDataTable = true;
            this.tableViewCurrent = tableData;
        },
        getValueFieldSubTable(item) {
            let typeField = item.type;
            let result = '';
            if (TYPE_CONTENT_TEXT.includes(typeField)) {
                result = item.value;
                if ([TYPE_MULTI_SELECT, TYPE_CHECK_BOX].includes(typeField)) {
                    if (this.$ld.isArray(item.value)) {
                        item.value = item.value.join(';');
                    }
                    result = item.value ? item.value.replaceAll(';', ', ') : '';
                }
            } else if (TYPE_CONTENT_DATE.includes(typeField)) {
                result = typeField === TYPE_DATE_TIME ? formatDateTime(item.value, 'YYYY/MM/DD HH:mm') : formatDateTime(item.value, 'YYYY/MM/DD');
            } else if (typeField === TYPE_NUMBER && item.value) {
                result = addComasNumber(Number(item.value));
            } else {
                result = item.value;
            }
            return result;
        },
        getTitleByKey(keyTitle, fieldTable = '') {
            let result = '';
            if (this.listFields) {
                let index = this.listFields.findIndex((elm) => elm.code === keyTitle);
                if (index >= 0) {
                    if (!fieldTable) {
                        result = this.listFields[index] ? this.listFields[index].label : '';
                    } else {
                        let fields = this.listFields[index] && this.listFields[index]['fields'] ? this.listFields[index]['fields'] : null;
                        if (fields) {
                            result = fields[fieldTable] && fields[fieldTable].label ? fields[fieldTable].label : '';
                        }
                    }
                }
            }
            return result;
        },
        getQueryString() {
            let query = [`last_id=${this.lastId}`, `limit=${this.limit}`];
            if (this.$route.query.query_list) {
                query.push(`filters=${this.$route.query.query_list}`);
            }
            return query.join('&');
        },
        prevPage() {
            if (this.lastId && this.lastId !== 0) {
                this.lastId = this.lastId - this.limit;
                let queryId = this.$route.query.id;
                this.page -= 1;
                this.handleGetDataShares(queryId);
            }
        },
        nextPage() {
            let lengthData = this.listDataShares.length || 0;
            if (this.lastId !== null && lengthData === this.limit) {
                this.page += 1;
                this.lastId = this.lastId + this.limit;
                let queryId = this.$route.query.id;
                this.handleGetDataShares(queryId);
            }
        },
        onChangeLimit() {
            let queryId = this.$route.query.id;
            this.handleGetDataShares(queryId);
        }
    }
};
</script>
